import { ISectorState } from "@/core/interfaces/sectorState.interface";

const sectorState: ISectorState = {
  sectors: [],
  isFetchingSectors: false,
  sectorProductivity: null,
  sectorStats: null,
  isSectorProductivityLoading: false,
  isSectorStatsLoading: false,
};

export default sectorState;
